import { featureFlags } from './featureFlags';
import { version } from '../../package.json';

export const environment = {
  environment: 'TESTING',
  production: true,
  version,
  lastUpdate: '2020-12-16 13:25',
  chatUrl: 'wss://chat.egzotech.dev',
  stellaAwareServerUrl: 'wss://direct-hub.egzotech.com',
  directHubFormat: 'msgpack',
  filtersConfigUrl: 'https://cdn.egzotech.com/config/filter-rms-3.json',
  authServerUrl: 'https://api.app.test.egzotech.dev/api/auth',
  restServerUrl: 'https://api.app.test.egzotech.dev/api',
  assetsUrl: 'https://storage.googleapis.com',
  gamesUrl: 'https://games-dev.stella.bio/',
  stimConfigurationUrl: 'https://git.egzotech.com/EGZOTech/stella-configuration-files/raw/master/stim-programs.json',
  stripePkey: 'pk_test_rLjQ6fkQqjOSP4kzVxjbXKXc00RdJOHFVf',
  expectStellaConnection: true,
  ...featureFlags,
  autoSelectClinic: true,
  autoSelectPatient: false,
  showRxDescriptions: true,
  maintenancePassword: '',
  telemedicine: false,
  allowDirectHubOverride: false,
  lightningChartLicense: '0001-2615b-14ef4-75a5c-40bd0-ca43a-c69ef-566dc-4fb95-9e6a9-e44fa-03227-f80fc-29fd8-70100-00932-94d3d'
};
